import { render, staticRenderFns } from "./efficiency.vue?vue&type=template&id=0604e3c0&"
import script from "./efficiency.vue?vue&type=script&lang=js&"
export * from "./efficiency.vue?vue&type=script&lang=js&"
import style0 from "./efficiency.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports